import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyMenu as MatMenu } from '@angular/material/legacy-menu';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { ROLES_LIST, USER } from 'src/app/app-data';
import { ApiService } from 'src/app/shared/services/api.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit {

  public isLoginUser: BehaviorSubject<boolean> = this.localStorageService.isLoginUser;
  public userRole: string = '';
  public roleName: string = '';
  public notiCount: number = 2;
  public notiData: any[] = [];
  public unreadNotificationCount: number = 0;
  public tempUser: boolean = false;
  public franchiseName: string = '';

  userName: string = '';

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private apiService: ApiService
  ) {
    this.isLoginUser.subscribe((r) => {
      const currUser: USER = this.localStorageService.getUser();
      this.userRole = (currUser && currUser.role) ? currUser.role : '';
      this.tempUser = (currUser && currUser.temp_user == true) ? true : false;
      this.franchiseName = (currUser && currUser.franchisee_name) ? currUser.franchisee_name : '';
      this.userName = (currUser && currUser.username) ? currUser.username : '';

      this.roleName = ROLES_LIST[this.userRole as keyof typeof ROLES_LIST];
      if (this.userRole === 'Franchise Partner' && this.tempUser == false) {
        this.getNotifications();
      }
    });
  }
  @ViewChild(MatMenu) matMenu: MatMenu | undefined;
  isMenuOpen = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  // To detect if the menu is open
  onMenuOpened() {
    this.isMenuOpen = true;
  }

  onMenuClosed() {
    this.isMenuOpen = false;
  }
  ngOnInit(): void {
  }

  getNotifications() {
    let apiUrlPath: string = environment.routes.NOTI_LIST;
    this.apiService.get(apiUrlPath).subscribe({
      next: (response) => {
        if (response?.status == 200) {
          this.notiData = response.data;
          this.unreadNotificationCount = this.notiData.filter(notification => !notification.is_read).length;
        }
      },
      error: (e) => { },
      complete: () => { },
    });
  }
  markAsRead(notification: any) {
    if (!notification.is_read) {
      // Immediately mark as read in the UI to prevent reverting
      notification.is_read = true;
      let apiUrlPath: string = environment.routes.NOTI_UPDATE;
      let payload = {
        id: notification?.id,
        isRead: notification?.is_read
      }

      // this.localStorageService.hide();
      // Call API to mark it as read
      this.apiService.put(apiUrlPath, payload).subscribe(
        (response: any) => {
          this.getNotifications();
          console.error("Success to mark notification as read", response);
        },
        (error) => {
          console.error("Failed to mark notification as read", error);
        });
    }
  }


  logout() {
    this.authService.logout();
  }
}
